import { render, staticRenderFns } from "./auction.vue?vue&type=template&id=2abf20dc&scoped=true&"
import script from "./auction.vue?vue&type=script&lang=js&"
export * from "./auction.vue?vue&type=script&lang=js&"
import style0 from "./auction.vue?vue&type=style&index=0&id=2abf20dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf20dc",
  null
  
)

export default component.exports